import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { Option, Rating, ScorecardRatings } from '@core/interview-results-types';
import { InterviewEvaluationRatingComponent } from '@core/interview-results-ui';
import { DividerComponent, HeadingComponent } from '@core/user-interface-legacy';
import { snakeCase } from '@core/utils-legacy';

@Component({
  selector: 'rt-scorecards-item-row',
  templateUrl: 'scorecards-item-row.component.html',
  styleUrls: ['./scorecards-item-row.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent, InterviewEvaluationRatingComponent, DividerComponent],
})
export class ScorecardsItemRowComponent {
  @Input()
  public set option(value: Option) {
    this.title = value.title;
    this.ratings = this.convertRatings(value.ratings);
  }

  public title: string;
  public ratings: Rating[];

  public trackByRating(index: number, rating: Rating): string {
    return rating.ratingKey + index;
  }

  private convertRatings(ratings: ScorecardRatings[]): Rating[] {
    const convertedRatings: Rating[] = [];
    ratings.forEach(rating => {
      Object.keys(rating).map(objectKey => {
        convertedRatings.push({
          ratingKey: snakeCase(objectKey),
          count: rating[<keyof ScorecardRatings>objectKey]!,
        });
      });
    });
    return convertedRatings;
  }
}
